<aside class="app-sidebar sticky" id="sidebar">
  <!-- Start::main-sidebar-header -->
  <div class="main-sidebar-header">
    <div class="header-logo">
      <div class="logo-container">
        <div class="wrapper">
          <img
            src="./assets/images/eteryal-logo.png"
            alt="logo"
            class="desktop-logo"
          />
          <p class="logo-text">Eteryal</p>
        </div>
      </div>
      <img
        src="./assets/images/eteryal-logo.png"
        alt="logo"
        class="toggle-logo"
      />
    </div>
  </div>
  <!-- End::main-sidebar-header -->
  <overlay-scrollbars
    [defer]
    class="main-sidebar simplebar-scrollable-y"
    id="sidebar-scroll"
  >
    <nav class="main-menu-container nav nav-pills flex-column sub-open">
      <div class="slide-left" id="slide-left" (click)="leftArrowFn()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#7b8191"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
          ></path>
        </svg>
      </div>

      <ul class="main-menu" [ngStyle]="{ display: 'block' }">
        @for (menuItem of menuItems; track menuItem) {
        <li
          class="slide"
          [ngClass]="{
            slide__category: menuItem.headTitle,
            'slide has-sub': menuItem.title,
            open: menuItem.active,
            active: menuItem.selected
          }"
        >
          <!-- head title  -->
          <!-- has-Link -->
          @if (menuItem.type === 'link') {
          <a
            class="side-menu__item"
            [routerLink]="!menuItem.type ? null : [menuItem.path]"
            routerLinkActive="active"
            (click)="setNavActive($event, menuItem.path ?? '')"
          >
            @if (menuItem.icon) {
            <i class="side-menu__icon  bi {{ menuItem.icon }}"></i>
            }
            <span class="side-menu__label">{{ menuItem.title }}</span>
          </a>
          }
          <!-- has-empty -->
          @if (menuItem.type === 'empty') {
          <a
            class="side-menu__item"
            href="javascript:;"
            (click)="setNavActive($event, menuItem.path ?? '')"
          >
            @if (menuItem.icon) {
            <i class="side-menu__icon demoicon ri-{{ menuItem.icon }}"></i>
            }
            <span class="side-menu__label">{{ menuItem.title }}</span>
          </a>
          }
          <!-- has-Sub -->
          @if (menuItem.type === 'sub') {
          <a
            class="side-menu__item"
            [routerLink]="menuItem.type ? null : [menuItem.path]"
            [ngClass]="{ active: menuItem.selected }"
            (click)="toggleNavActive($event, menuItem)"
          >
            @if (menuItem.icon) {
            <i class="side-menu__icon  bi {{ menuItem.icon }}"></i>
            }
            <span class="side-menu__label">{{ menuItem.title }}</span>
            @if (menuItem.badgeClass && menuItem.badgeValue) {
            <span class="badge {{ menuItem.badgeClass }} side-badge">
              {{ menuItem.badgeValue }}
            </span>
            }
            <i class="fe fe-chevron-right side-menu__angle"></i>
          </a>
          }
          <!-- 2nd Level menu -->
          @if (menuItem.children) {
          <ul
            class="slide-menu child1"
            [ngClass]="{
              active: menuItem.active,
              'double-menu-active': menuItem.active,
              'force-left': menuItem.dirchange
            }"
            [ngStyle]="{ display: menuItem.active ? 'block' : 'none' }"
          >
            <li class="slide side-menu__label1">
              <a href="javascript:void(0)">{{ menuItem.title }}</a>
            </li>
            @for (childrenItem of menuItem.children; track childrenItem) {
            <li
              class="slide"
              [ngClass]="{ active: childrenItem.selected }"
              appDropdownPosition
              [ngClass]="{
                'has-sub': childrenItem.type === 'sub',
                active: childrenItem.selected
              }"
            >
              <!-- link -->
              @if (childrenItem.type === 'link') {
              <a
                class="side-menu__item"
                [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="setNavActive($event, childrenItem.path ?? '')"
              >
                {{ childrenItem.title }}
              </a>
              }
              <!-- empty -->
              @if (childrenItem.type === 'empty' ) {
              <a
                class="side-menu__item"
                href="javascript:;"
                (click)="setNavActive($event, childrenItem.path ?? '')"
              >
                {{ childrenItem.title }}
              </a>
              }
              <!-- sub -->
              @if (childrenItem.type === 'sub') {
              <a
                class="side-menu__item"
                [ngClass]="{ active: childrenItem.selected }"
                [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                (click)="toggleNavActive($event, childrenItem)"
              >
                <span class="">{{ childrenItem.title }}</span>
                <i class="fe fe-chevron-right side-menu__angle"></i>
              </a>
              }
              <!-- 3rd Level menu -->
              @if (childrenItem.children) {
              <ul
                class="slide-menu child2"
                [ngClass]="{ 'force-left': childrenItem.dirchange }"
                [ngStyle]="{
                                  display: childrenItem.active ? 'block' : 'none',
                              
                                }"
              >
                @for (childrenSubItem of childrenItem.children; track
                childrenSubItem) {
                <li
                  class="slide"
                  appDropdownPosition
                  [ngClass]="{ open: childrenSubItem.active }"
                >
                  @if (childrenSubItem.type === 'link') {
                  <a
                    class="side-menu__item"
                    routerLinkActive="active"
                    [routerLink]="
                      !childrenSubItem.type ? null : [childrenSubItem.path]
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    {{ childrenSubItem.title }}
                  </a>
                  } @if (childrenSubItem.type === 'empty') {
                  <a class="side-menu__item" href="javascript:;">
                    {{ childrenSubItem.title }}
                  </a>
                  } @if (childrenSubItem.type === 'sub') {
                  <a
                    class="side-menu__item"
                    [ngClass]="{ active: childrenSubItem.active }"
                    [routerLink]="
                      childrenSubItem.type ? null : [childrenSubItem.path]
                    "
                    routerLinkActive="active"
                    (click)="toggleNavActive($event, childrenSubItem)"
                  >
                    <span class="">{{ childrenSubItem.title }}</span>
                    <i class="fe fe-chevron-right side-menu__angle"></i>
                  </a>
                  }
                  <!-- 3rd Level menu -->
                  @if (childrenSubItem.children) {
                  <ul
                    class="slide-menu child2"
                    [ngClass]="{ 'force-left': childrenItem.dirchange }"
                    [ngStyle]="{
                                                          display: childrenSubItem.active ? 'block' : 'none',
                                                      
                                                        }"
                  >
                    @for (childrenSubItem1 of childrenSubItem.children; track
                    childrenSubItem1) {
                    <li
                      class="slide"
                      [ngClass]="{ open: childrenSubItem1.active }"
                    >
                      @if (childrenSubItem1.type === 'link') {
                      <a
                        class="side-menu__item"
                        routerLinkActive="active"
                        [routerLink]="
                          !childrenSubItem1.type
                            ? null
                            : [childrenSubItem1.path]
                        "
                        [routerLinkActiveOptions]="{ exact: true }"
                      >
                        {{ childrenSubItem1.title }}
                      </a>
                      } @if (childrenSubItem1.type === 'empty') {
                      <a class="side-menu__item" href="javascript:;">
                        {{ childrenSubItem1.title }}
                      </a>
                      }
                    </li>
                    }
                  </ul>
                  }
                </li>
                }
              </ul>
              }
            </li>
            }
          </ul>
          }
        </li>
        }
        <!-- End::slide -->
      </ul>
      <div class="slide-right" id="slide-right" (click)="rightArrowFn()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#7b8191"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"
          ></path>
        </svg>
      </div>
    </nav>
  </overlay-scrollbars>
</aside>
